<div
  class="text-widget"
  [style.font-family]="fontFamily"
  [style.font-size.cqw]="fontSize"
  [style.font-weight]="textWidget.font_weight || 'normal'"
  [style.font-style]="textWidget.font_style || 'normal'"
  [style.color]="textColor"
  [style.text-align]="textWidget.text_align || 'left'"
  [style.text-decoration]="textWidget.text_decoration || 'none'"
  [style.letter-spacing.cqw]="(textWidget.letter_spacing || 0) / 10"
  [style.background-color]="textWidget.background_color || 'transparent'"
  [style.opacity]="textWidget.opacity || 1"
  [style.border-color]="textWidget.border_color || 'transparent'"
  [style.border-width.cqw]="(textWidget.border_width || 0) / 10"
  [style.border-style]="(textWidget.border_width || 0) > 0 ? 'solid' : 'none'"
  [style.line-height]="textWidget.line_height || 1"
  (dblclick)="startEdit($event)"
>
  @if (!isEditing) {
    {{ textWidget.text }}
  } @else {
    <textarea
      #editor
      class="text-widget-editor"
      [formControl]="editControl"
      (mousedown)="stopEvent($event)"
      (mouseup)="stopEvent($event)"
      (click)="stopEvent($event)"
      (dblclick)="stopEvent($event)"
      (input)="textCommitted.emit(editControl.value)"
      (blur)="commitEdit($event)"
      (keydown)="onEditorKeydown($event)"
    ></textarea>
  }
</div>
